import type { PlatformSubpageConfig, PlatformSubpageSlug } from '../types';
import { apisIntegrationsConfig } from './apis-integrations';
import { dashboardConfig } from './dashboard';
import { deviceManagementConfig } from './device-management';
import { firmwareSdkConfig } from './firmware-sdk';
import { iotCloudConfig } from './iot-cloud';
import { mobileAppsConfig } from './mobile-apps';
import { securityConfig } from './security';

export const platformSubpages: Record<PlatformSubpageSlug, PlatformSubpageConfig> = {
  'iot-cloud': iotCloudConfig,
  'firmware-sdk': firmwareSdkConfig,
  dashboard: dashboardConfig,
  'mobile-apps': mobileAppsConfig,
  'apis-integrations': apisIntegrationsConfig,
  security: securityConfig,
  'device-management': deviceManagementConfig,
};

export const platformSubpageList = Object.values(platformSubpages);

export function getPlatformSubpage(slug: PlatformSubpageSlug): PlatformSubpageConfig {
  return platformSubpages[slug];
}

export { iotCloudTabs } from './iot-cloud';
export { firmwareChips } from './firmware-sdk';
export { dashboardModules } from './dashboard';
export { apiIntegrationsList, apiCodeSamples } from './apis-integrations';
export { securityStats, securityCompliance } from './security';
export { deviceMgmtSteps } from './device-management';
